<ion-row class="th-text" [ngClass]="{ 'align-header-right': rightAlign }">
  {{ columnText }}
</ion-row>
<ion-row class="dropdown-search-wrapper">
  <div
    class="dropdown-container"
    [ngClass]="{ 'right-align-dropdown': rightAlign }"
  >
    <div class="checkbox-search" [ngClass]="checkboxSearchWidthClass">
      @if (showTooltip) {
        <div
          class="custom-filter-container"
          onkeypress="updateDropdown()"
          #tooltip="matTooltip"
          [matTooltip]="toolTipText"
          [matTooltipPosition]="'right'"
          (click)="updateDropdown()"
        >
          <span class="selected-icon">
            <span class="dropdown-text">{{ displayedTitle }}</span>
            <img [src]="IMAGES.CHEVRON" alt="search" />
          </span>
        </div>
      }
      @if (!showTooltip) {
        <div
          class="custom-filter-container"
          (click)="updateDropdown()"
          onkeypress="updateDropdown()"
        >
          <span class="selected-icon">
            <span class="dropdown-text">{{ displayedTitle }}</span>
            <img [src]="IMAGES.CHEVRON" alt="search" />
          </span>
        </div>
      }
      @if (showDropdown) {
        <div class="search-results">
          <ion-item-group class="item-group">
            <ion-item
              lines="none"
              (click)="selectAll()"
              onkeypress="selectAll()"
            >
              <ion-checkbox
                class="checkbox"
                labelPlacement="end"
                justify="start"
                [(ngModel)]="selectAllModel"
              >
                <div>
                  {{ SELECT_ALL_LABEL }}
                </div>
              </ion-checkbox>
            </ion-item>
            @for (value of searchResults; track value) {
              <ion-item
                lines="none"
                (click)="updateCheckbox()"
                onkeypress="updateCheckbox()"
              >
                <ion-checkbox
                  class="checkbox"
                  labelPlacement="end"
                  justify="start"
                  [(ngModel)]="value.selected"
                >
                  <div>
                    {{ value.id }}
                  </div>
                </ion-checkbox>
              </ion-item>
            }
          </ion-item-group>
        </div>
      }
    </div>
  </div>
</ion-row>
